import * as s from "./website-head-submenu-content.scss";
import {ProductType} from "../../../../../../../models/product/ProductType";
import {Network} from "../../../../../../../network/Network";
import {Resources} from "../../../../../../../resources/Resources";
import {CapsuleComponent} from "../../../../../../panel/components/components/capsule/CapsuleComponent";
import {WebsiteHeadSubmenuContentComponent} from "./WebsiteHeadSubmenuContentComponent";

export class WebsiteHeadSubmenuContentUseCaseComponent extends WebsiteHeadSubmenuContentComponent {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteHeadSubmenuContent}">
                <div class="${s.column}">
                    <h6 class="${s.title}">
                        ${Resources.t("words.useCases")}
                        <span class="${s.arrow}"></span>
                    </h6>
                    <div class="${s.cases}">
                        <a itemprop="url" href="${Network.router.pages.getUrlWithPath('service-client')}">
                            <div class="${s.case} ${s.serviceClient}">
                                <div class="${s.capsuleContainer}">
                                    ${this.draw(new CapsuleComponent(ProductType.CLIENT_SERVICE))}
                                </div>
                                <div class="${s.texts}">
                                    <p itemprop="name" class="${s.caseTitle}">
                                        ${Resources.t("words.customerService")}
                                    </p>
                                    <p class="${s.description}">
                                        ${Resources.t("words.supportCustomers")}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        `;
    }

    commit() {
        this.el(s.serviceClient).onClick(() => {
            Network.router.pages.redirect("/service-client");
        });
        super.commit();
    }
}